import EditGuestModal from './EditGuestModal';

export default EditGuestModal;
